import { Translation } from '../types';

export const el: Translation = {
  common: {
    loading: 'Φόρτωση...',
    error: 'Σφάλμα',
    cancel: 'Ακύρωση',
    save: 'Αποθήκευση',
    close: 'Κλείσιμο',
    search: 'Αναζήτηση',
    reload: 'Ανανέωση',
    logout: 'Αποσύνδεση',
    dashboard: 'Πίνακας Ελέγχου',
    products: 'Προϊόντα',
    settings: 'Ρυθμίσεις',
    language: 'Γλώσσα',
    businessHours: 'Ωράριο Λειτουργίας',
    back: 'Πίσω',
    selectAll: 'Επιλογή Όλων',
    deselectAll: 'Αποεπιλογή Όλων',
    success: 'Επιτυχία',
    selected: 'Επιλεγμένα',
    confirm: 'Επιβεβαίωση',
    required: 'Απαιτείται',
    requiredMarker: '*',
    previous: 'Προηγούμενο',
    next: 'Επόμενο',
    allRightsReserved: 'Με την επιφύλαξη παντός δικαιώματος.',
  },
  auth: {
    login: 'Σύνδεση',
    email: 'Διεύθυνση Email',
    password: 'Κωδικός Πρόσβασης',
    loginButton: 'Σύνδεση',
    loggingIn: 'Γίνεται σύνδεση...',
    loginSuccess: 'Επιτυχής σύνδεση',
    loginError: 'Το email ή ο κωδικός πρόσβασης είναι λανθασμένα',
    invalidEmail: 'Παρακαλώ εισάγετε έγκυρη διεύθυνση email',
    requiredFields: 'Παρακαλώ εισάγετε email και κωδικό πρόσβασης',
    demoAccount: 'Λογαριασμός επίδειξης:',
    loginDescription: 'Εισάγετε τα στοιχεία του λογαριασμού σας για να συνδεθείτε',
    welcomeMessage: 'Καλώς ήρθατε στο σύστημα παραγγελιών επιχειρήσεων',
    // Registration
    register: 'Εγγραφή',
    createAccount: 'Δημιουργία Λογαριασμού',
    confirmPassword: 'Επιβεβαίωση Κωδικού Πρόσβασης',
    passwordRequirements: 'Ο κωδικός πρέπει να έχει τουλάχιστον 8 χαρακτήρες με κεφαλαία, πεζά, αριθμό και ειδικό χαρακτήρα',
    passwordsDoNotMatch: 'Οι κωδικοί πρόσβασης δεν ταιριάζουν',
    registrationSuccess: 'Επιτυχής εγγραφή',
    registrationDescription: 'Εγγραφείτε για επαγγελματικό λογαριασμό',
    alreadyHaveAccount: 'Έχετε ήδη λογαριασμό;',
    signIn: 'Συνδεθείτε',
    dontHaveAccount: 'Δεν έχετε λογαριασμό;',
    creatingAccount: 'Δημιουργία λογαριασμού...',
    registrationNote: 'Σημείωση:',
    registrationNotePoints: {
      erpLinking: 'Εάν έχετε ήδη επαγγελματικό λογαριασμό, το email σας θα συνδεθεί αυτόματα',
      companyEmail: 'Παρακαλώ χρησιμοποιήστε το εταιρικό σας email για την εγγραφή',
      contactSupport: 'Επικοινωνήστε με την υποστήριξη αν χρειάζεστε βοήθεια με την εγγραφή'
    },
    b2bUsers: 'Χρήστες Επαγγελματικού Λογαριασμού:',
    registeredEmail: 'Εγγεγραμμένη διεύθυνση email',
    registeredPassword: 'Κωδικός πρόσβασης που ορίστηκε κατά την εγγραφή',
    b2bCustomerRequired: 'Αυτή η διεύθυνση email δεν είναι εγγεγραμμένη ως επαγγελματικός πελάτης. Παρακαλώ επικοινωνήστε με τις πωλήσεις για να δημιουργήσετε επαγγελματική σχέση πρώτα.',
    b2bVerificationError: 'Αδυναμία επαλήθευσης κατάστασης επαγγελματικού πελάτη. Παρακαλώ επικοινωνήστε με την υποστήριξη.',
    // Password Reset
    passwordReset: 'Επαναφορά Κωδικού Πρόσβασης',
    passwordResetDescription: 'Εισάγετε τη διεύθυνση email σας για να λάβετε προσωρινό κωδικό',
    getTemporaryPassword: 'Λήψη Προσωρινού Κωδικού',
    processing: 'Επεξεργασία...',
    passwordResetComplete: 'Ολοκλήρωση Επαναφοράς Κωδικού',
    temporaryPasswordGenerated: 'Ο προσωρινός κωδικός έχει δημιουργηθεί',
    temporaryPassword: 'Προσωρινός Κωδικός',
    backToLogin: 'Επιστροφή στη Σύνδεση',
    securityNotice: 'Σημείωση Ασφαλείας:',
    securityNotePoints: {
      keepSecret: 'Μην κοινοποιήσετε τον προσωρινό κωδικό σε άλλους',
      changeAfterLogin: 'Βεβαιωθείτε ότι θα αλλάξετε τον κωδικό σας μετά τη σύνδεση',
      expires24Hours: 'Ο προσωρινός κωδικός λήγει μετά από 24 ώρες'
    },
    resetNote: 'Σημείωση:',
    resetNotePoints: {
      registeredEmail: 'Εισάγετε την εγγεγραμμένη διεύθυνση email σας',
      passwordDisplayed: 'Ο προσωρινός κωδικός θα εμφανιστεί στην οθόνη',
      changeRequired: 'Απαιτείται αλλαγή κωδικού μετά τη σύνδεση'
    },
    copied: 'Αντιγράφηκε',
    copySuccessMessage: 'Ο προσωρινός κωδικός αντιγράφηκε στο πρόχειρο.',
    forgotPassword: 'Ξεχάσατε τον κωδικό;',
    // Password Reset Email Request
    sendResetLink: 'Αποστολή Συνδέσμου Επαναφοράς',
    sendingEmail: 'Αποστολή email...',
    emailSent: 'Email Εστάλη',
    emailSentMessage: 'Εάν αυτή η διεύθυνση email υπάρχει στο σύστημά μας, θα λάβετε σύντομα έναν σύνδεσμο επαναφοράς κωδικού.',
    emailNotSent: 'Το email δεν εστάλη',
    emailSentInfo: 'Ελέγξτε τα εισερχόμενά σας και τον φάκελο ανεπιθύμητων',
    checkEmail: 'Ελέγξτε το Email',
    emailInstructions: 'Οι οδηγίες επαναφοράς κωδικού έχουν σταλεί',
    nextSteps: 'Επόμενα Βήματα:',
    nextStepsList: {
      checkInbox: 'Ελέγξτε τα εισερχόμενά σας και τον φάκελο ανεπιθύμητων',
      clickLink: 'Κάντε κλικ στον σύνδεσμο επαναφοράς στο email',
      linkExpires: 'Ο σύνδεσμος λήγει σε 24 ώρες',
      contactSupport: 'Επικοινωνήστε με την υποστήριξη αν δεν λάβετε το email',
      rateLimitInfo: 'Περιορίζεται σε 3 αιτήματα ανά ώρα'
    },
    // Password Reset Completion
    resetLinkSent: 'Σύνδεσμος Επαναφοράς Εστάλη',
    resetSuccess: 'Επιτυχής Επαναφορά Κωδικού',
    passwordUpdated: 'Ο Κωδικός Ενημερώθηκε',
    passwordUpdateMessage: 'Ο κωδικός σας ενημερώθηκε επιτυχώς. Τώρα μπορείτε να συνδεθείτε με τον νέο κωδικό.',
    loginWithNewPassword: 'Σύνδεση με Νέο Κωδικό',
    // Reset Token Page
    resetToken: 'Επαναφορά Κωδικού',
    invalidToken: 'Μη έγκυρο διακριτικό επαναφοράς',
    expiredToken: 'Το διακριτικό επαναφοράς έχει λήξει',
    tokenValid: 'Το διακριτικό επαναφοράς είναι έγκυρο',
    newPassword: 'Νέος Κωδικός',
    confirmNewPassword: 'Επιβεβαίωση Νέου Κωδικού',
    updatePassword: 'Ενημέρωση Κωδικού',
    updatingPassword: 'Ενημέρωση κωδικού...',
    passwordMismatch: 'Οι κωδικοί δεν ταιριάζουν',
    resetInstructions: 'Εισάγετε τον νέο κωδικό σας για να ολοκληρώσετε την επαναφορά',
  },
  accountInfo: {
    title: 'Πληροφορίες Λογαριασμού',
    loading: 'Φόρτωση πληροφοριών λογαριασμού...',
    error: 'Σφάλμα',
    errorMessage: 'Αποτυχία ανάκτησης πληροφοριών λογαριασμού',
    back: 'Πίσω',
    basicInfo: 'Βασικές Πληροφορίες',
    name: 'Όνομα',
    email: 'Διεύθυνση Email',
    contactId: 'ID Πελάτη Knitido',
    contactNumber: 'Αριθμός Επικοινωνίας',
    noInfo: 'Καμία πληροφορία',
    companyInfo: 'Πληροφορίες Εταιρείας',
    company: 'Επωνυμία Εταιρείας',
    position: 'Θέση',
    vatId: 'ΑΦΜ',
    billingAddress: 'Διεύθυνση Χρέωσης',
    deliveryAddress: 'Διεύθυνση Παράδοσης',
    addressInfo: 'Πληροφορίες Διεύθυνσης',
    billingDescription: 'Διεύθυνση για τιμολόγια και έγγραφα σύμβασης',
    deliveryDescription: 'Τυπική διεύθυνση παράδοσης για αποστολές προϊόντων',
    sameAsBilling: '※ Ίδια με τη διεύθυνση χρέωσης',
    sameAsDelivery: '※ Ίδια με τη διεύθυνση παράδοσης',
    companyName: 'Επωνυμία Εταιρείας',
    contactPerson: 'Πρόσωπο Επικοινωνίας',
    address: 'Διεύθυνση',
    phoneNumber: 'Τηλέφωνο',
    billingUsage: 'Χρησιμοποιείται ως προορισμός για τιμολόγια, συμβάσεις και άλλα σημαντικά έγγραφα',
    deliveryUsage: 'Χρησιμοποιείται ως τυπική διεύθυνση παράδοσης για παραγγελίες προϊόντων',
    alsoUsedForDelivery: 'Χρησιμοποιείται επίσης ως προορισμός παράδοσης',
    accountType: 'Τύπος Λογαριασμού',
    addressId: 'ID Διεύθυνσης',
    // Address editing functionality
    edit: 'Επεξεργασία',
    editDeliveryAddress: 'Επεξεργασία Διεύθυνσης Παράδοσης',
    editDeliveryDescription: 'Ενημερώστε τα στοιχεία της διεύθυνσης παράδοσής σας',
    newDeliveryAddress: 'Προσθήκη Νέας Διεύθυνσης Παράδοσης',
    newDeliveryDescription: 'Εισάγετε τα στοιχεία για τη νέα διεύθυνση παράδοσης',
    noDeliveryAddress: 'Δεν έχει οριστεί διεύθυνση παράδοσης',
    success: 'Επιτυχία',
    addressUpdated: 'Η διεύθυνση παράδοσης ενημερώθηκε επιτυχώς',
    updateError: 'Αποτυχία ενημέρωσης διεύθυνσης παράδοσης',
    requiredFields: 'Παρακαλώ συμπληρώστε όλα τα απαιτούμενα πεδία',
    firstName: 'Όνομα',
    lastName: 'Επώνυμο',
    streetAddress: 'Οδός και Αριθμός',
    streetAddress2: 'Διεύθυνση 2 (Όροφος, Διαμέρισμα κ.λπ.)',
    city: 'Πόλη',
    country: 'Χώρα',
    selectCountry: 'Επιλογή χώρας...',
    searchCountry: 'Αναζήτηση χώρας...',
    noCountryFound: 'Δεν βρέθηκε χώρα.',
    postalCode: 'Τ.Κ.',
    companyNamePlaceholder: 'Εισάγετε επωνυμία εταιρείας',
    firstNamePlaceholder: 'Όνομα',
    lastNamePlaceholder: 'Επώνυμο',
    streetAddressPlaceholder: 'Εισάγετε οδό και αριθμό',
    streetAddress2Placeholder: 'Διαμέρισμα, κτίριο, κ.λπ.',
    cityPlaceholder: 'Εισάγετε πόλη',
    postalCodePlaceholder: 'Εισάγετε Τ.Κ.',
    billingNotEditable: 'Η διεύθυνση χρέωσης δεν μπορεί να τροποποιηθεί.',
    billingContactSupport: 'Επικοινωνήστε με την υποστήριξη για αλλαγές.',
    // Multiple delivery addresses
    deliveryAddressCount: '{count} διευθύνσεις παράδοσης',
    noDeliveryAddresses: 'Δεν υπάρχουν καταχωρημένες διευθύνσεις παράδοσης',
    defaultAddress: 'Προεπιλογή',
    selectDeliveryAddress: 'Επιλογή διεύθυνσης παράδοσης',
    addNewAddress: 'Προσθήκη νέας διεύθυνσης',
    editAddress: 'Επεξεργασία διεύθυνσης',
    deleteAddress: 'Διαγραφή διεύθυνσης',
    confirmDelete: 'Επιβεβαίωση διαγραφής',
    confirmDeleteMessage: 'Είστε βέβαιοι ότι θέλετε να διαγράψετε αυτή τη διεύθυνση; Αυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    addressAddedSuccess: 'Η διεύθυνση παράδοσης προστέθηκε',
    addressDeletedSuccess: 'Η διεύθυνση παράδοσης διαγράφηκε',
    deleteError: 'Αποτυχία διαγραφής διεύθυνσης παράδοσης',
    saving: 'Αποθήκευση...',
    cancel: 'Ακύρωση',
    saveChanges: 'Αποθήκευση αλλαγών',
    selectedDeliveryAddress: 'Επιλεγμένη διεύθυνση παράδοσης',
  },
  dashboard: {
    title: 'Συνεργάτης B2B',
    subtitle: 'Σύστημα Παραγγελίας Προϊόντων',
    welcome: 'Καλώς ήρθατε,',
    welcomeMessage: 'Καλώς ήρθατε στο σύστημα παραγγελιών Συνεργατών B2B. Μπορείτε να παραγγείλετε προϊόντα εδώ.',
    productCatalog: 'Κατάλογος Προϊόντων',
    productCatalogDesc: 'Περιηγηθείτε και παραγγείλετε διαθέσιμα προϊόντα',
    viewProducts: 'Προβολή Προϊόντων',
    orderHistory: 'Ιστορικό Παραγγελιών',
    orderHistoryDesc: 'Προβολή προηγούμενων παραγγελιών (σύντομα)',
    accountSettings: 'Ρυθμίσεις Λογαριασμού',
    accountSettingsDesc: 'Διαχείριση πληροφοριών λογαριασμού (σύντομα)',
    comingSoon: 'Σύντομα κοντά σας',
    infoTitle: 'Σχετικά με τη χρήση',
    orderingInfo: 'Παραγγελία Προϊόντων',
    orderingDesc: 'Επιλέξτε προϊόντα από τον κατάλογο και καθορίστε μέγεθος και χρώμα. Διατίθενται πληροφορίες αποθέματος σε πραγματικό χρόνο.',
    supportInfo: 'Υποστήριξη',
    supportDesc: 'Εάν έχετε ερωτήσεις, παρακαλώ επικοινωνήστε μαζί μας.',
    viewOrderHistory: 'Προβολή Ιστορικού Παραγγελιών',
    viewOrders: 'Προβολή Παραγγελιών',
    accountInfo: 'Πληροφορίες Λογαριασμού',
    accountInfoDesc: 'Προβολή στοιχείων λογαριασμού',
    viewDetails: 'Προβολή Λεπτομερειών',
    supportEmail: 'b2b-partner @knitido.de',
    supportPhone: '+49(0)30 6640 9300',
    businessHours: 'Δευτέρα-Παρασκευή 9:00 ΠΜ - 3:00 ΜΜ CET',
    bulkImportDesc: 'Εισαγωγή παραγγελιών από αρχεία Excel/CSV',
    importOrders: 'Εισαγωγή Παραγγελιών',
  },
  products: {
    title: 'Λίστα Προϊόντων',
    subtitle: 'Συνεργάτης B2B',
    searchPlaceholder: 'Αναζήτηση με όνομα προϊόντος ή SKU...',
    productId: 'ID Προϊόντος',
    addToCart: 'Προσθήκη στο Καλάθι',
    selectVariation: 'Επιλογή Παραλλαγής',
    price: 'Τιμή',
    priceNetNotice: 'Όλες οι τιμές είναι καθαρές τιμές',
    stock: 'Απόθεμα',
    color: 'Χρώμα',
    newProducts: 'Νέα Προϊόντα',
    newProductBadge: 'ΝΕΟ',
    size: 'Μέγεθος',
    quantity: 'Ποσότητα',
    total: 'Σύνολο',
    cart: 'Καλάθι',
    checkout: 'Ταμείο',
    csvMode: 'Γρήγορη Λειτουργία CSV',
    csvInfo: 'Δεδομένα προϊόντων που ανακτήθηκαν από δεδομένα CSV',
    csvUploadDate: 'Ημερομηνία Μεταφόρτωσης CSV:',
    stockNote: '※ Οι πληροφορίες αποθέματος ανακτώνται κατά την επιλογή παραλλαγών προϊόντος',
    noProducts: 'Δεν βρέθηκαν προϊόντα',
    noProductsDesc: 'Αλλάξτε τα κριτήρια αναζήτησης ή μεταφορτώστε ένα αρχείο CSV για ταχύτερη απόδοση.',
    retry: 'Δοκιμή ξανά',
    pagination: 'αντικείμενα',
    variations: 'παραλλαγές',
    stockFetchError: 'Σφάλμα ανάκτησης αποθέματος',
    stockFetchFailed: 'Η ανάκτηση αποθέματος απέτυχε',
    stockFetchFailedDesc: 'Αδυναμία ανάκτησης πληροφοριών αποθέματος. Θα εμφανιστεί το απόθεμα CSV.',
    stockFetched: 'Πληροφορίες αποθέματος ανακτήθηκαν',
    totalStock: 'Συνολικό απόθεμα',
    noStockAll: 'Όλες οι παραλλαγές έχουν μηδενικό απόθεμα',
    noStockData: 'Δεν επιστράφηκαν δεδομένα αποθέματος',
    stockFetchErrorDesc: 'Παρουσιάστηκε σφάλμα κατά την ανάκτηση πληροφοριών αποθέματος',
    selectionError: 'Σφάλμα επιλογής',
    enterQuantity: 'Παρακαλώ εισάγετε ποσότητα',
    addedToCart: 'Προστέθηκε στο καλάθι',
    typesAdded: ' τύποι προϊόντων προστέθηκαν',
    addToCartError: 'Σφάλμα κατά την προσθήκη στο καλάθι',
    addToCartErrorDesc: 'Παρακαλώ δοκιμάστε ξανά',
    loadingStock: 'Φόρτωση πληροφοριών αποθέματος',
    csvDataInfo: 'Εμφάνιση πληροφοριών δεδομένων CSV (όχι πραγματικά επίπεδα αποθέματος)',
    invalidDataFormat: 'Η μορφή δεδομένων προϊόντος δεν είναι έγκυρη',
    loadFailed: 'Αποτυχία φόρτωσης δεδομένων προϊόντος',
    csvUploadComplete: 'Η μεταφόρτωση CSV ολοκληρώθηκε',
    csvLoadedDesc: ' δεδομένα προϊόντων φορτώθηκαν. Οι πληροφορίες αποθέματος θα ανακτηθούν κατά την επιλογή προϊόντων.',
    searchTitle: 'Αναζήτηση Προϊόντων',
    loadingProducts: 'Φόρτωση δεδομένων προϊόντων',
    noProductsCsv: 'Δεν βρέθηκαν προϊόντα στα δεδομένα CSV. Παρακαλώ αλλάξτε τα κριτήρια αναζήτησης.',
    paginationDisplay: ' εμφανίζονται',
    previous: 'Προηγούμενο',
    next: 'Επόμενο',
    selectionSummary: 'Σύνοψη Επιλογής',
    selectedQuantity: 'Επιλεγμένη Ποσότητα',
    items: ' αντικείμενα',
    viewDetails: 'Προβολή Λεπτομερειών',
    productImage: 'Εικόνα Προϊόντος',
    correspondingVariations: 'Αντίστοιχες Παραλλαγές',
    clickToEnlarge: 'Κλικ για μεγέθυνση',
    productIdLabel: 'ID Προϊόντος',
    colorLabel: 'Χρώμα',
    filterByCategory: 'Φίλτρο ανά Κατηγορία',
    allProducts: 'Όλα τα Προϊόντα',
    applyFilters: 'Εφαρμογή Φίλτρων',
    clearFilters: 'Καθαρισμός Φίλτρων',
    filters: 'Φίλτρα',
    clearAll: 'Καθαρισμός όλων',
  },
  categories: {
    category_21: 'Κάλτσες με Δάχτυλα',
    category_23: 'Χωρίς Κατηγορία',
    category_24: 'Ενδύματα',
    category_29: 'Προϊόντα B2B',
  },
  productDetail: {
    title: 'Λεπτομέρειες Προϊόντος',
    backToProducts: 'Πίσω στα Προϊόντα',
    productNotFound: 'Το Προϊόν Δεν Βρέθηκε',
    productNotFoundDesc: 'Το καθορισμένο προϊόν δεν υπάρχει ή έχει διαγραφεί.',
    loading: 'Φόρτωση προϊόντος...',
    imageLoadError: 'Αποτυχία φόρτωσης εικόνων',
    noImages: 'Δεν υπάρχουν διαθέσιμες εικόνες',
    productDescription: 'Περιγραφή Προϊόντος',
    colors: 'Χρώματα',
    sizes: 'Μεγέθη',
    colorCount: 'χρώματα',
    sizeCount: 'μεγέθη',
    variationCount: 'παραλλαγές',
    selectVariation: 'Επιλογή Παραλλαγών',
    descriptionLanguageNote: '※ Οι περιγραφές προϊόντων είναι διαθέσιμες μόνο στα Αγγλικά ή Γερμανικά',
  },
  colors: {
    schwarz: 'Μαύρο',
    weiß: 'Λευκό',
    grau: 'Γκρι',
    rot: 'Κόκκινο',
    blau: 'Μπλε',
    grün: 'Πράσινο',
    gelb: 'Κίτρινο',
    rosa: 'Ροζ',
    lila: 'Μωβ',
    braun: 'Καφέ',
    orange: 'Πορτοκαλί',
    beige: 'Μπεζ',
    navy: 'Ναυτικό Μπλε',
    dunkelblau: 'Σκούρο Μπλε',
    hellblau: 'Ανοιχτό Μπλε',
    dunkelgrau: 'Σκούρο Γκρι',
    hellgrau: 'Ανοιχτό Γκρι',
    bordeaux: 'Μπορντό',
    türkis: 'Τυρκουάζ',
    khaki: 'Χακί',
    mint: 'Μέντα',
    violett: 'Βιολετί',
    anthrazit: 'Ανθρακί',
    blaugrau: 'Μπλε Γκρι',
    burgunderrot: 'Βουργουνδί',
    elfenbein: 'Ιβουάρ',
    karminrot: 'Καρμίν',
    neongrün: 'Νέον Πράσινο',
    gelbgrün: 'Κιτρινοπράσινο',
    pistazie: 'Φιστικί',
    // English color names
    blue: 'Μπλε',
    ivory: 'Ιβουάρ',
    green: 'Πράσινο',
    gold: 'Χρυσό',
    red: 'Κόκκινο',
  },
  checkout: {
    title: 'Ταμείο',
    cartReview: 'Επισκόπηση Παραγγελίας',
    orderSummary: 'Σύνοψη Παραγγελίας',
    shippingInfo: 'Πληροφορίες Αποστολής',
    billingInfo: 'Πληροφορίες Χρέωσης',
    orderNotes: 'Σημειώσεις Παραγγελίας',
    orderNotesPlaceholder: 'Ειδικά αιτήματα ή σημειώσεις...',
    contactPerson: 'Πρόσωπο Επικοινωνίας',
    phoneNumber: 'Τηλέφωνο',
    email: 'Διεύθυνση Email',
    company: 'Εταιρεία',
    address: 'Διεύθυνση',
    city: 'Πόλη',
    postalCode: 'Τ.Κ.',
    country: 'Χώρα',
    deliveryDate: 'Ημερομηνία Παράδοσης',
    urgentDelivery: 'Εξπρές Παράδοση (3-5 εργάσιμες)',
    standardDelivery: 'Τυπική Παράδοση (7-10 εργάσιμες)',
    placeOrder: 'Υποβολή Παραγγελίας',
    backToCart: 'Πίσω στην Επιλογή Προϊόντων',
    requiredField: 'Απαιτούμενο πεδίο',
    orderTotal: 'Σύνολο Παραγγελίας',
    subtotal: 'Υποσύνολο',
    priceNetNotice: 'Όλες οι τιμές είναι καθαρές τιμές',
    stockReservationNotice: 'Η κράτηση αποθέματος θα γίνει μετά την επιβεβαίωση της παραγγελίας.',
    stockCheckError: 'Σφάλμα Ελέγχου Αποθέματος',
    stockCheckErrorDesc: 'Παρουσιάστηκε σφάλμα κατά τον έλεγχο αποθέματος. Παρακαλώ δοκιμάστε ξανά.',
    shipping: 'Αποστολή',
    shippingCost: 'Κόστος Αποστολής',
    tax: 'Φόρος',
    orderSuccess: 'Επιτυχής Παραγγελία',
    orderSuccessMessage: 'Η παραγγελία σας υποβλήθηκε επιτυχώς. Αριθμός παραγγελίας: {orderNumber}',
    orderNumber: 'Αριθμός Παραγγελίας',
    thankYou: 'Ευχαριστούμε για την παραγγελία σας!',
    orderConfirmation: 'Η παραγγελία σας υποβλήθηκε επιτυχώς.',
    orderProcessing: 'Μετά από έλεγχο από την ομάδα μας, θα σας στείλουμε επιβεβαίωση παραγγελίας μέσω email.',
    orderProcessingMessage: 'Η παραγγελία σας υποβλήθηκε επιτυχώς. Μετά από έλεγχο από την ομάδα μας, θα σας στείλουμε επιβεβαίωση παραγγελίας μέσω email.',
    continueShopping: 'Συνέχεια Αγορών',
    emptyCart: 'Το καλάθι σας είναι άδειο',
    emptyCartMessage: 'Παρακαλώ προσθέστε προϊόντα στο καλάθι για να συνεχίσετε',
    stockWarning: 'Προειδοποίηση Αποθέματος',
    stockWarningDesc: 'Ορισμένα είδη έχουν ανεπαρκές απόθεμα. Παρακαλώ προσαρμόστε τις ποσότητες.',
    stockError: 'Σφάλμα Αποθέματος',
    stockErrorDesc: 'Υπάρχουν είδη με ανεπαρκές απόθεμα. Παρακαλώ προσαρμόστε τις ποσότητες.',
    refreshStock: 'Ανανέωση Αποθέματος',
    stockUpdated: 'Το Απόθεμα Ενημερώθηκε',
    stockUpdatedDesc: 'Το απόθεμα ενημερώθηκε - {changed} είδη άλλαξαν',
    stockCheckDesc: 'Εμφανίζονται τα αποτελέσματα σύγκρισης με το απόθεμα',
    stockOk: 'Απόθεμα OK',
    stockShortage: 'Έλλειψη Αποθέματος',
    requestedQty: 'Ζητούμενη Ποσ.',
    currentStock: 'Τρέχον Απόθεμα',
    stockShortageMsg: 'Ανεπαρκές απόθεμα. Παρακαλώ προσαρμόστε την ποσότητα.',
    stockIssueWarning: 'Η παραγγελία δεν μπορεί να επιβεβαιωθεί λόγω προβλημάτων αποθέματος.',
    stockDataMissing: 'Τα δεδομένα αποθέματος ανακτώνται. Παρακαλώ περιμένετε.',
    outOfStock: 'Εξαντλημένο.',
    maxAvailable: 'Μέγιστο',
    autoRestored: 'Το καλάθι αποκαταστάθηκε',
    autoRestoredDesc: 'Τα είδη από την τελευταία σας σύνοδο αποκαταστάθηκαν',
    maxQuantityReached: 'Επιτεύχθηκε η μέγιστη ποσότητα αποθέματος.',
    // ERP Contact Search
    contactSearch: 'Αναζήτηση Επαφής Πελάτη',
    contactSearchDesc: 'Εισάγετε τη διεύθυνση email του παραγγέλλοντος για να ανακτήσετε πληροφορίες επαφής',
    emailAddress: 'Διεύθυνση Email',
    searchButton: 'Αναζήτηση',
    searching: 'Αναζήτηση',
    contactFound: 'Επαφή Βρέθηκε',
    contactNotFound: 'Επαφή Δεν Βρέθηκε',
    contactId: 'ID Πελάτη Knitido',
    companyName: 'Εταιρεία',
    contactPersonLabel: 'Πρόσωπο Επικοινωνίας',
    addressesFound: 'Διευθύνσεις Βρέθηκαν',
    addressType: 'Τύπος',
    addressBilling: 'Διεύθυνση Χρέωσης',
    addressDelivery: 'Διεύθυνση Παράδοσης',
    vatSourceCompany: 'Πληροφορίες Εταιρείας',
    vatSourceBilling: 'Χρέωση',
    vatSourceDelivery: 'Παράδοση',
    addressOther: 'Άλλο',
    addressDetails: 'Διεύθυνση',
    loadingAddresses: 'Φόρτωση πληροφοριών διεύθυνσης...',
    addressRetrieved: 'Πληροφορίες διεύθυνσης ανακτήθηκαν',
    addressNotFound: 'Πληροφορίες διεύθυνσης δεν βρέθηκαν',
    addressNotFoundDesc: 'Δεν υπάρχουν καταχωρημένες πληροφορίες διεύθυνσης. Παρακαλώ εισάγετε χειροκίνητα.',
    addressError: 'Σφάλμα Ανάκτησης Διεύθυνσης',
    addressErrorDesc: 'Αποτυχία ανάκτησης πληροφοριών διεύθυνσης.',
    contactNotConfirmed: 'Η Επαφή Πελάτη Δεν Επιβεβαιώθηκε',
    contactNotConfirmedDesc: 'Παρακαλώ εισάγετε διεύθυνση email και αναζητήστε την επαφή.',
    searchContact: 'Αναζήτηση Επαφής',
    inputError: 'Σφάλμα Εισαγωγής',
    inputErrorDesc: 'Οι πληροφορίες αποστολής είναι ελλιπείς. Παρακαλώ ελέγξτε.',
    processing: 'Επεξεργασία...',
    erpContactSearch: 'Αναζήτηση Επαφής Πελάτη',
    contactSearchError: 'Η διεύθυνση email δεν αντιστοιχεί σε καμία καταχωρημένη επαφή.',
    // Product Images Toggle
    showProductImages: 'Εμφάνιση Εικόνων Προϊόντων',
    showProductImagesDesc: 'Εμφάνιση εικόνων προϊόντων για καλύτερη επισκόπηση (μπορεί να αυξήσει τον χρόνο φόρτωσης)',
    // System Registration Info
    systemRegistrationInfo: 'Τα Στοιχεία Πελάτη Σας',
    editShippingAddress: 'Επεξεργασία Διεύθυνσης Παράδοσης',
    systemRegistrationInfoDesc: 'Τα καταχωρημένα επαγγελματικά σας στοιχεία. Παρακαλώ επικοινωνήστε με τον αντιπρόσωπό σας αν χρειάζεται να ενημερώσετε τα στοιχεία διεύθυνσης χρέωσης.',
    // Order Summary
    regularPrice: 'Κανονική Τιμή Χονδρικής',
    offeredPrice: 'Προσφερόμενη Τιμή',
    discount: 'Έκπτωση',
    b2bCustomer: 'Πελάτης B2B',
    pattern: 'Μοτίβο',
    specialPriceApplied: 'Εφαρμόστηκε ειδική τιμή',
    customerClassification: 'Κατηγοριοποίηση Πελάτη',
    paymentCondition: 'Όροι Πληρωμής',
    invoice: 'Τιμολόγιο (NET 30)',
    prepayment: 'Προπληρωμή',
    paymentMethod: 'Μέθοδος Πληρωμής',
    invoicePayment: 'Πληρωμή με Τιμολόγιο',
    estimatedSubtotal: 'Εκτιμώμενο Υποσύνολο',
    estimatedTotal: 'Εκτιμώμενο Σύνολο',
    orderSummaryDisclaimer: 'Οι τιμές που εμφανίζονται εδώ είναι εκτιμήσεις. Μόλις λάβουμε την παραγγελία σας, θα την ελέγξουμε και θα σας στείλουμε δεσμευτική επιβεβαίωση παραγγελίας με τις τελικές τιμές, έξοδα αποστολής και φόρους μέσω email.',
    searchError: 'Σφάλμα Αναζήτησης',
    searchErrorDesc: 'Παρουσιάστηκε σφάλμα κατά την αναζήτηση επαφής.',
    confirmDeleteItem: 'Αφαίρεση Είδους',
    itemDeleted: 'Το είδος αφαιρέθηκε',
    confirmDeleteItemDesc: 'Είστε βέβαιοι ότι θέλετε να αφαιρέσετε το ακόλουθο είδος από το καλάθι;',
    deleteConfirm: 'Αφαίρεση',
    contactNotes: 'Σημειώσεις Επαφής',
    contactNotesDesc: 'Έχετε ερωτήσεις ή ειδικά αιτήματα; Παρακαλώ ενημερώστε μας (προαιρετικό)',
    contactNotesLabel: 'Μήνυμα',
    contactNotesPlaceholder: 'π.χ.: Ερωτήσεις για προϊόντα, ειδικές απαιτήσεις, κ.λπ.',
    characters: 'χαρακτήρες',
    contactIdLabel: 'ID Πελάτη Knitido',
    companyLabel: 'Εταιρεία',
    personLabel: 'Πρόσωπο Επικοινωνίας',
    emailLabel: 'Email',
    addressTypeLabel: 'Τύπος',
    destinationLabel: 'Προορισμός',
    // Shipping Form
    shippingTitle: 'Πληροφορίες Αποστολής',
    shippingDesc: 'Εισάγετε τη διεύθυνση παράδοσης για τα προϊόντα',
    companyRequired: 'Εταιρεία *',
    contactPersonRequired: 'Πρόσωπο Επικοινωνίας *',
    emailRequired: 'Διεύθυνση Email *',
    phoneRequired: 'Τηλέφωνο *',
    addressRequired: 'Διεύθυνση 1 *',
    address2: 'Διεύθυνση 2 (Κτίριο/Δωμάτιο)',
    postalCodeRequired: 'Τ.Κ. *',
    cityRequired: 'Πόλη *',
    countryRequired: 'Χώρα *',
    selectCountry: 'Επιλογή Χώρας',
    shippingMethodRequired: 'Μέθοδος Αποστολής *',
    selectShippingMethod: 'Επιλογή Μεθόδου Αποστολής',
    urgentDeliveryOption: 'Εξπρές Παράδοση (πρόσθετες χρεώσεις)',
    deliveryNotes: 'Σημειώσεις Παράδοσης',
    deliveryNotesPlaceholder: 'Εισάγετε προτιμήσεις χρόνου παράδοσης ή άλλα αιτήματα',
    standardShipping: 'Τυπική Αποστολή (3-5 εργάσιμες)',
    expressShipping: 'Εξπρές Αποστολή (1-2 εργάσιμες)',
    overnightShipping: 'Αποστολή Επόμενης Ημέρας',
    germany: 'Γερμανία',
    austria: 'Αυστρία',
    switzerland: 'Ελβετία',
    japan: 'Ιαπωνία',
    shippingAddressLabel: 'Διεύθυνση Παράδοσης',
    changeDeliveryAddress: 'Αλλαγή Διεύθυνσης Παράδοσης',
    selectDeliveryAddress: 'Επιλογή Διεύθυνσης Παράδοσης',
    // Shipping Cost Details
    freeShipping: 'Δωρεάν Αποστολή',
    shippingError: 'Σφάλμα',
    shippingZone: 'Ζώνη Αποστολής',
    remainingForFreeShipping: '{amount} ακόμη για δωρεάν αποστολή',
    moreForFreeShipping: 'ακόμη για δωρεάν αποστολή',
    freeShippingProgress: 'Δωρεάν αποστολή στα',
    andAboveFreeShipping: 'και άνω για δωρεάν αποστολή',
    freeShippingAchieved: 'Εφαρμόστηκε δωρεάν αποστολή',
    threshold: 'και άνω',
    nextShippingTier: 'Επόμενη έκπτωση αποστολής',
    moreForDiscount: 'ακόμη για',
    shippingSavings: 'εξοικονόμηση αποστολής',
    orderAmountThreshold: 'και άνω για',
    specialRegionNotice: 'Εφαρμόστηκε ειδική περιοχή αποστολής',
    defaultShippingApplied: 'Εφαρμόστηκαν τυπικές τιμές αποστολής',
    requestedQuantity: 'Ζητούμενη Ποσότητα',
    availableQuantity: 'Διαθέσιμη Ποσότητα',
    orderSubmitError: 'Σφάλμα παραγγελίας',
    orderSubmitErrorDesc: 'Αποτυχία υποβολής παραγγελίας',
    upload: {
      title: 'Εισαγωγή Παραγγελίας Excel/CSV',
      description: 'Μεταφορτώστε ένα αρχείο Excel ή CSV με τα δεδομένα της παραγγελίας σας',
      dragDropOrClick: 'Σύρετε και αφήστε το αρχείο εδώ ή κάντε κλικ για επιλογή',
      dropHere: 'Αφήστε το αρχείο εδώ',
      supportedFormats: 'Υποστηριζόμενες μορφές: Excel (.xlsx, .xls) και CSV (.csv)',
      maxSize: 'Μέγιστο μέγεθος αρχείου: {size} MB',
      processFile: 'Επεξεργασία Αρχείου',
      processing: 'Επεξεργασία αρχείου...',
      ready: 'Αρχείο έτοιμο για προεπισκόπηση',
      readyDescription: 'Το αρχείο σας επεξεργάστηκε επιτυχώς και είναι έτοιμο για έλεγχο.',
      preview: 'Προβολή Προεπισκόπησης',
      errors: {
        fileTooLarge: 'Το αρχείο είναι πολύ μεγάλο. Μέγιστο μέγεθος: {size} MB',
        invalidFileType: 'Μη έγκυρος τύπος αρχείου. Παρακαλώ μεταφορτώστε αρχείο Excel ή CSV',
        uploadFailed: 'Σφάλμα μεταφόρτωσης αρχείου',
      },
    },
    // Loading messages
    loadingPage: 'Φόρτωση σελίδας...',
    loadingStock: 'Έλεγχος αποθέματος προϊόντων...',
    loadingAccount: 'Φόρτωση πληροφοριών λογαριασμού...',
    loadingError: 'Παρουσιάστηκε σφάλμα...',
    loadingData: 'Φόρτωση δεδομένων',
    // Toast messages
    addressRetrievedTitle: 'Πληροφορίες διεύθυνσης ανακτήθηκαν',
    addressSetAsDelivery: ' η διεύθυνση ορίστηκε ως προορισμός παράδοσης.',
    contactFoundDesc: ' αναγνωρίστηκε.'
  },
  orderHistory: {
    title: 'Ιστορικό Παραγγελιών',
    searchPlaceholder: 'Αναζήτηση με αριθμό παραγγελίας ή SKU...',
    noOrders: 'Δεν βρέθηκαν παραγγελίες',
    noOrdersFound: 'Δεν βρέθηκαν αντίστοιχες παραγγελίες',
    startShopping: 'Προβολή Προϊόντων',
    orderItems: 'Είδη Παραγγελίας',
    viewDetails: 'Λεπτομέρειες',
    reorder: 'Επαναπαραγγελία',
    orderDate: 'Ημερομηνία Παραγγελίας',
    orderStatus: 'Κατάσταση',
    orderTotal: 'Σύνολο Παραγγελίας',
    // Status translations
    statusPending: 'Εκκρεμεί Πληρωμή',
    statusProcessing: 'Υπό Επεξεργασία',
    statusConfirmed: 'Επιβεβαιώθηκε',
    statusShipped: 'Απεστάλη',
    statusDelivered: 'Παραδόθηκε',
    statusCancelled: 'Ακυρώθηκε',
    statusReturned: 'Επεστράφη',
    statusRefunded: 'Επιστροφή Χρημάτων',
    statusWarranty: 'Εγγύηση',
    statusExchanged: 'Ανταλλάχθηκε',
    statusRepair: 'Επισκευή',
    statusUnknown: 'Άγνωστο',
    statusIncomplete: 'Ελλιπής',
    statusWaitingPayment: 'Αναμονή Πληρωμής',
    statusInPreparation: 'Σε Προετοιμασία',
    statusClearedShipping: 'Εγκρίθηκε για Αποστολή',
    statusBeingShipped: 'Αποστέλλεται',
    statusOutgoingBooked: 'Εξερχόμενη Καταχωρήθηκε',
    statusReturn: 'Επιστροφή',
    // Additional UI elements
    itemCount: 'αντικείμενα',
    itemCountSingular: 'αντικείμενο',
    refreshButton: 'Ανανέωση',
    errorFetchingOrders: 'Αποτυχία ανάκτησης ιστορικού παραγγελιών',
    // Payment status features
    paymentStatus: 'Κατάσταση Πληρωμής',
    markAsPaid: 'Σήμανση ως Πληρωμένο',
    unmarkAsPaid: 'Ακύρωση Σήμανσης Πληρωμής',
    paidOn: 'Πληρώθηκε στις',
    paymentMarked: 'Πληρωμένο',
    notPaid: 'Μη Πληρωμένο',
    paymentMarkedSuccess: 'Επιτυχής σήμανση ως πληρωμένο',
    paymentUnmarkedSuccess: 'Αφαίρεση σήμανσης πληρωμής',
    paymentUpdateError: 'Αποτυχία ενημέρωσης κατάστασης πληρωμής',
    // Payment date dialog
    paymentDateTitle: 'Εισαγωγή Πληροφοριών Πληρωμής',
    paymentDateDescription: 'Εισάγετε πληροφορίες πληρωμής για την παραγγελία {orderNumber}',
    paymentDateLabel: 'Ημερομηνία Πληρωμής',
    selectDate: 'Επιλογή ημερομηνίας',
    paymentDateHelp: 'Επιλέξτε την ημερομηνία πραγματοποίησης της τραπεζικής μεταφοράς',
    paymentMethodLabel: 'Μέθοδος Πληρωμής',
    bankTransfer: 'Τραπεζική Μεταφορά',
    invoice: 'Τιμολόγιο',
    otherPayment: 'Άλλο',
    paymentReferenceLabel: 'Όνομα Μεταφοράς / Αριθμός Αναφοράς',
    paymentReferencePlaceholder: 'π.χ., Γιάννης Παπαδόπουλος, Μεταφορά #12345',
    paymentReferenceHelp: 'Εισάγετε πληροφορίες που βοηθούν στην ταύτιση με τις τραπεζικές κινήσεις',
    notesLabel: 'Σημειώσεις',
    notesPlaceholder: 'Εισάγετε τυχόν πρόσθετες πληροφορίες πληρωμής',
    // Filter options
    filterByPaymentStatus: 'Φίλτρο ανά Κατάσταση Πληρωμής',
    allOrders: 'Όλες οι Παραγγελίες',
    paidOrders: 'Πληρωμένες',
    unpaidOrders: 'Μη Πληρωμένες',
    // Sorting options
    sortBy: 'Ταξινόμηση κατά',
    sortByDate: 'Ημερομηνία Παραγγελίας',
    sortByPaymentDate: 'Ημερομηνία Πληρωμής',
    sortByAmount: 'Ποσό',
    sortByStatus: 'Κατάσταση',
  },
  orderDetails: {
    title: 'Λεπτομέρειες Παραγγελίας',
    notFound: 'Η παραγγελία δεν βρέθηκε',
    backToHistory: 'Πίσω στο Ιστορικό Παραγγελιών',
    orderDate: 'Ημερομηνία Παραγγελίας',
    orderItems: 'Είδη Παραγγελίας',
    deliveryStatus: 'Κατάσταση Παράδοσης',
    estimatedDelivery: 'Εκτιμώμενη Παράδοση',
    deliveredOn: 'Παραδόθηκε στις',
    downloadInvoice: 'Λήψη Τιμολογίου',
    statusDelivered: 'Παραδόθηκε',
    statusShipped: 'Απεστάλη',
    statusConfirmed: 'Επιβεβαιώθηκε',
    statusCancelled: 'Ακυρώθηκε',
    errorFetchingDetails: 'Αποτυχία ανάκτησης λεπτομερειών παραγγελίας',
  },
  company: {
    name: 'Συνεργάτης B2B',
    tagline: 'Σύστημα Συνεργατών B2B',
    copyright: '© 2025 Σύστημα Συνεργατών B2B. Με την επιφύλαξη παντός δικαιώματος.',
  },
  footer: {
    phone: 'Τηλέφωνο',
    email: 'Email',
    countries: {
      DE: 'Γερμανία',
      AT: 'Αυστρία',
      CH: 'Ελβετία',
      FR: 'Γαλλία',
      IT: 'Ιταλία',
      ES: 'Ισπανία',
      NL: 'Ολλανδία',
      BE: 'Βέλγιο',
      PL: 'Πολωνία',
      SE: 'Σουηδία',
      NO: 'Νορβηγία',
      FI: 'Φινλανδία',
      DK: 'Δανία',
      LT: 'Λιθουανία',
      LV: 'Λετονία',
      EE: 'Εσθονία',
    },
  },
  cart: {
    newCart: 'Νέο Καλάθι',
    currentCart: 'Τρέχον Καλάθι',
    modified: 'τροποποιήθηκε',
    lastSaved: 'Τελευταία αποθήκευση',
    unsavedChanges: 'μη αποθηκευμένες αλλαγές',
    saveCart: 'Αποθήκευση Καλαθιού',
    loadCart: 'Φόρτωση Καλαθιού',
    deleteCart: 'Διαγραφή Καλαθιού',
    startNewCart: 'Έναρξη Νέου Καλαθιού',
    savedCarts: 'Αποθηκευμένα Καλάθια',
    cartSaved: 'Το καλάθι αποθηκεύτηκε',
    cartDeleted: 'Το καλάθι διαγράφηκε',
    confirmDeleteCart: 'Διαγραφή καλαθιού;\n\nΑυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    confirmSwitchCart: 'Το τρέχον καλάθι έχει μη αποθηκευμένες αλλαγές.\n\nΗ φόρτωση άλλου καλαθιού θα προκαλέσει απώλεια των τρεχουσών αλλαγών.\n\nΣυνέχεια;',
    confirmSwitchCartTitle: 'Αλλαγή Καλαθιού',
    confirmNewCart: 'Το τρέχον καλάθι έχει μη αποθηκευμένες αλλαγές.\n\nΗ έναρξη νέου καλαθιού θα προκαλέσει απώλεια των τρεχουσών αλλαγών.\n\nΣυνέχεια;',
    confirmNewCartTitle: 'Έναρξη Νέου Καλαθιού',
    confirmClearCart: 'Εκκαθάριση καλαθιού;\n\n{count} αντικείμενα θα αφαιρεθούν.\n\nΑυτή η ενέργεια δεν μπορεί να αναιρεθεί.',
    confirmClearCartTitle: 'Εκκαθάριση Καλαθιού',
    autoSaved: 'Αυτόματη αποθήκευση',
    itemsWillBeRemoved: 'αντικείμενα θα αφαιρεθούν',
    changesWillBeLost: 'αλλαγές θα χαθούν',
    continueQuestion: 'Συνέχεια;',
    cartStatus: 'Κατάσταση Καλαθιού',
    cartName: 'Όνομα Καλαθιού',
    cartNamePlaceholder: 'π.χ.: Παραγγελία τέλους μήνα',
    cartNameRequired: 'Παρακαλώ εισάγετε όνομα καλαθιού',
    saveCartDescription: 'Δώστε όνομα στο τρέχον καλάθι και αποθηκεύστε το. Μπορείτε να το φορτώσετε αργότερα.',
    cancelCart: 'Ακύρωση Καλαθιού',
    proceedToCheckout: 'Προχωρήστε στο Ταμείο',
    emptyCart: 'Το καλάθι είναι άδειο',
    erpDown: 'Το σύστημα παραγγελιών είναι εκτός λειτουργίας. Δοκιμάστε ξανά αργότερα.',
    erpDegraded: 'Το σύστημα είναι αυτή τη στιγμή ασταθές. Οι παραγγελίες ενδέχεται να αποτύχουν.',
    erpDownSaveHint: 'Αποθηκεύστε το καλάθι σας και παραγγείλετε όταν αποκατασταθεί το σύστημα.',
    erpSaveCart: 'Αποθήκευση καλαθιού',
  },
  nav: {
    dashboard: 'Πίνακας Ελέγχου',
    products: 'Προϊόντα',
    orderHistory: 'Ιστορικό Παραγγελιών',
    account: 'Στοιχεία Λογαριασμού',
    bulkImport: 'Μαζική Εισαγωγή',
  },
  settings: {
    selectLanguage: 'Επιλέξτε Γλώσσα',
    languagePreferenceSaved: 'Η προτίμησή σας θα αποθηκευτεί στον λογαριασμό σας για μελλοντικές επισκέψεις.',
  },
  reorder: {
    allItemsAdded: '{count} αντικείμενα προστέθηκαν στο καλάθι',
    partialSuccess: '{added} αντικείμενα προστέθηκαν. {failed} αντικείμενα δεν μπόρεσαν να προστεθούν',
    allItemsFailed: 'Αποτυχία προσθήκης αντικειμένων στο καλάθι',
    error: 'Παρουσιάστηκε σφάλμα κατά την επαναπαραγγελία',
    itemDiscontinued: 'Το {name} ({color}/{size}) έχει καταργηθεί',
    itemOutOfStock: 'Το {name} ({color}/{size}) έχει εξαντληθεί',
    partialStock: 'Το {name} ({color}/{size}) έχει μόνο {available} διαθέσιμα',
    confirmReorder: 'Επιβεβαίωση Επαναπαραγγελίας',
    confirmReorderMessage: 'Προσθήκη αντικειμένων από αυτή την παραγγελία στο καλάθι σας;',
    addingToCart: 'Προσθήκη στο καλάθι...',
    checkingStock: 'Έλεγχος αποθέματος...',
    checkoutTitle: 'Αντικείμενα Προστέθηκαν στο Καλάθι',
    checkoutDescription: '{count} αντικείμενα προστέθηκαν στο καλάθι σας. Θέλετε να προχωρήσετε στο ταμείο;',
  },
  bulkImport: {
    instructions: 'Πώς να Εισάγετε Παραγγελίες',
    step1: 'Κατεβάστε το αρχείο προτύπου παραγγελίας',
    step2: 'Συμπληρώστε τα δεδομένα της παραγγελίας σας με SKU και ποσότητα',
    step3: 'Αποθηκεύστε ως αρχείο Excel (.xlsx) ή CSV',
    step4: 'Μεταφορτώστε το αρχείο χρησιμοποιώντας την παρακάτω φόρμα',
    step5: 'Ελέγξτε και επιβεβαιώστε την παραγγελία σας',
    downloadTemplate: 'Λήψη Προτύπου',
    downloadExcelTemplate: 'Λήψη Προτύπου Excel',
    downloadCsvTemplate: 'Λήψη Προτύπου CSV',
    formatGuide: 'Οδηγός Μορφής Αρχείου',
    requiredColumns: 'Απαιτούμενες Στήλες',
    skuDescription: 'Κωδικός SKU Προϊόντος',
    quantityDescription: 'Ποσότητα παραγγελίας (θετικός ακέραιος)',
    optionalColumns: 'Προαιρετικές Στήλες',
    notesDescription: 'Εσωτερικές σημειώσεις (π.χ. αριθμός PO, αναφορά) - μόνο για το αρχείο σας',
    formatNote: 'Η πρώτη γραμμή πρέπει να περιέχει κεφαλίδες στηλών. Τα δεδομένα ξεκινούν από τη δεύτερη γραμμή.',
    parseSuccess: 'Επιτυχής ανάλυση {count} αντικειμένων από το αρχείο',
    parseError: 'Σφάλμα Ανάλυσης',
    validationError: 'Σφάλματα Επικύρωσης',
    validationErrorGuidance: 'Παρακαλώ κάντε κλικ στο κουμπί "{showPreviewButton}" για να δείτε τις λεπτομέρειες.',
    warnings: 'Προειδοποιήσεις',
    itemsParsed: 'Επιτυχής ανάλυση {count} αντικειμένων:',
    andMore: '...και {count} ακόμη αντικείμενα',
    validationSummary: 'Σύνοψη Επικύρωσης',
    duplicateSKUs: 'Βρέθηκαν διπλότυπα SKU',
    skuFormat: 'Το SKU πρέπει να περιέχει μόνο γράμματα, αριθμούς και παύλες',
    quantityRange: 'Η ποσότητα πρέπει να είναι μεταξύ 1 και 9999',
    maxRows: 'Επιτρέπονται μέγιστο 1000 γραμμές',
    rowsSkipped: '{count} γραμμές παραλείφθηκαν λόγω σφαλμάτων',
    previewTitle: 'Προεπισκόπηση Παραγγελίας',
    previewDescription: 'Ελέγξτε και επεξεργαστείτε τα δεδομένα της παραγγελίας σας πριν προχωρήσετε',
    proceedToCart: 'Προσθήκη στο Καλάθι',
    // File parsing messages
    fileEmpty: 'Το αρχείο είναι άδειο ή δεν περιέχει δεδομένα',
    fileTooManyRows: 'Το αρχείο περιέχει πάρα πολλές γραμμές ({current}). Μέγιστο επιτρεπτό: {max}',
    invalidRowFormat: 'Μη έγκυρη μορφή γραμμής',
    missingColumns: 'Λείπουν απαιτούμενες στήλες (SKU και Ποσότητα)',
    missingSku: 'Λείπει το SKU',
    invalidSkuFormat: 'Μη έγκυρη μορφή SKU: "{sku}" (πρέπει να ταιριάζει με το πρότυπο: {pattern})',
    skuTooLong: 'Το SKU είναι πολύ μεγάλο: "{sku}" (μέγιστο 50 χαρακτήρες)',
    invalidQuantity: 'Μη έγκυρη ποσότητα: "{quantity}" δεν είναι αριθμός',
    quantityTooLow: 'Ποσότητα πολύ χαμηλή: {quantity} (ελάχιστο: {min})',
    quantityTooHigh: 'Ποσότητα πολύ υψηλή: {quantity} (μέγιστο: {max})',
    notesRequired: 'Το πεδίο σημειώσεων είναι υποχρεωτικό',
    noValidData: 'Δεν βρέθηκαν έγκυρα δεδομένα. Παρακαλώ ελέγξτε τη μορφή του αρχείου σας.',
    row: 'Γραμμή {row}: {errors}',
    rowErrors: '...και {count} ακόμη σφάλματα',
    duplicateSkuInRows: 'Διπλότυπο SKU "{sku}" βρέθηκε στις γραμμές: {rows}',
    quantityExceedsMax: 'Γραμμή {row}: Η ποσότητα {quantity} υπερβαίνει το μέγιστο επιτρεπτό ({max})',
    quantityBelowMin: 'Γραμμή {row}: Η ποσότητα {quantity} είναι κάτω από το ελάχιστο απαιτούμενο ({min})',
    // Validation messages
    unsupportedFileFormat: 'Μη υποστηριζόμενη μορφή αρχείου. Παρακαλώ μεταφορτώστε αρχείο CSV ή Excel.',
    csvParsingErrors: 'Παρουσιάστηκαν σφάλματα ανάλυσης CSV',
    failedToParseFile: 'Αποτυχία ανάλυσης αρχείου',
    failedToParseExcel: 'Αποτυχία ανάλυσης αρχείου Excel',
    failedToReadFile: 'Αποτυχία ανάγνωσης αρχείου',
    unknownError: 'Παρουσιάστηκε άγνωστο σφάλμα',
    totalRows: 'Σύνολο γραμμών',
    valid: 'Έγκυρο',
    invalid: 'Μη έγκυρο',
    skipped: 'Παραλείφθηκε',
    // SKU validation
    skuValidationError: 'Σφάλμα Επικύρωσης SKU',
    skuValidationFailed: 'Αποτυχία επικύρωσης SKU. Μπορείτε να προχωρήσετε, αλλά ορισμένα είδη μπορεί να μην είναι διαθέσιμα.',
    skuNotFound: 'Το SKU δεν βρέθηκε στη βάση δεδομένων',
    skusNotFound: '{count} SKU δεν βρέθηκαν στη βάση δεδομένων',
    itemsHaveInsufficientStock: '{count} είδη έχουν ανεπαρκές απόθεμα',
    validatingSKUs: 'Επικύρωση ειδών...',
    unvalidatedChanges: 'Έχετε μη επικυρωμένες αλλαγές. Παρακαλώ επανεπικυρώστε πριν την προσθήκη στο καλάθι.',
    revalidate: 'Επανεπικύρωση',
    validating: 'Επικύρωση...',
    validationSuccess: 'Όλα τα είδη είναι έγκυρα',
    validationComplete: 'Ολοκλήρωση Επικύρωσης',
    validationResultSummary: '{errors} σφάλματα, {warnings} προειδοποιήσεις βρέθηκαν',
    // Table headers
    actions: 'Ενέργειες',
    notes: 'Σημειώσεις',
    // Status filter
    all: 'Όλα',
    hasErrors: 'Έχει Σφάλματα',
    // Selection summary
    selected: 'επιλέχθηκαν',
    errors: 'σφάλματα',
    // Pagination
    page: 'Σελίδα {current} από {total}',
    previous: 'Προηγούμενο',
    next: 'Επόμενο',
    noResults: 'Κανένα αποτέλεσμα.',
    // Cart integration
    noValidItems: 'Κανένα Έγκυρο Είδος',
    allItemsHaveErrors: 'Όλα τα είδη έχουν σφάλματα επικύρωσης. Παρακαλώ διορθώστε τα πριν προχωρήσετε.',
    dataLoadingError: 'Σφάλμα Φόρτωσης Δεδομένων',
    failedToLoadProductData: 'Αποτυχία φόρτωσης δεδομένων προϊόντων. Παρακαλώ δοκιμάστε ξανά.',
    itemsAddedToCart: '{count} Είδη Προστέθηκαν στο Καλάθι',
    itemsAddedMessage: 'Προστέθηκαν {count} είδη στο καλάθι',
    someSkusNotFound: '{count} SKU δεν μπόρεσαν να βρεθούν.',
    noItemsAdded: 'Κανένα Είδος Δεν Προστέθηκε',
    couldNotFindProducts: 'Δεν μπόρεσαν να βρεθούν προϊόντα που αντιστοιχούν στα SKU.',
    errorAddingToCart: 'Σφάλμα',
    failedToAddToCart: 'Αποτυχία προσθήκης ειδών στο καλάθι. Παρακαλώ δοκιμάστε ξανά.',
    addingToCart: 'Προσθήκη στο καλάθι...',
    // File info
    fileSelected: '{name} επιλέχθηκε για επεξεργασία',
    fileSize: '{size} bytes',
    fileSizeKB: '{size} KB',
    fileSizeMB: '{size} MB',
    // Template download
    templateDownload: 'Λήψη Προτύπου',
    templateWillBeImplemented: 'Η λήψη προτύπου θα υλοποιηθεί στη Φάση 7',
    // Additional validation
    validationFailed: 'Η επικύρωση απέτυχε',
    // Template download
    templateDownloaded: 'Το πρότυπο λήφθηκε επιτυχώς',
    templateDownloadError: 'Αποτυχία λήψης προτύπου',
    // Template content
    sheetName: 'Μαζική Παραγγελία',
    instructionsSheetName: 'Οδηγίες',
    columnDescriptions: 'Περιγραφές Στηλών:',
    columnHeader: 'Στήλη',
    columnRequired: 'Απαιτείται',
    columnOptional: 'Προαιρετικό',
    columnDescription: 'Περιγραφή',
    templateNotes: 'Σημειώσεις:',
    templateNote1: 'Η πρώτη γραμμή πρέπει να περιέχει κεφαλίδες στηλών ακριβώς όπως φαίνεται',
    templateNote2: 'Τα δεδομένα ξεκινούν από τη γραμμή 2',
    templateNote3: 'Το SKU πρέπει να αντιστοιχεί σε υπάρχοντες κωδικούς προϊόντων στο σύστημα',
    templateNote4: 'Η ποσότητα πρέπει να είναι θετικός ακέραιος μεταξύ 1 και 9999',
    templateNote5: 'Μέγιστο 1000 γραμμές επιτρέπονται ανά αρχείο',
    templateNote6: 'Αποθήκευση ως μορφή .xlsx ή .csv',
    stockAvailabilityWarning: 'Η πραγματική διαθεσιμότητα αποθέματος θα ελεγχθεί στην επόμενη σελίδα ταμείου.',
    outOfStock: 'Εξαντλημένο',
    insufficientStock: 'Ανεπαρκές απόθεμα: {available} διαθέσιμα, {requested} ζητούμενα',
  },
  orderExport: {
    export: 'Εξαγωγή Παραγγελίας',
    exportOrder: 'Εξαγωγή Δεδομένων Παραγγελίας',
    exportAsCSV: 'Εξαγωγή ως CSV',
    exportAsExcel: 'Εξαγωγή ως Excel',
    exportForReorder: 'Εξαγωγή για Μαζική Εισαγωγή',
    detailed: 'Πλήρεις Λεπτομέρειες',
    simpleFormat: 'Μορφή Εισαγωγής',
  },
};
